export { SpatiusAvatarCanvas } from "@/components/spatius-avatar/spatius-avatar-canvas";
export type { SpatiusAvatarCanvasProps } from "@/components/spatius-avatar/spatius-avatar-canvas";

export { SpatiusAvatarError } from "@/components/spatius-avatar/spatius-avatar-error";
export type { SpatiusAvatarErrorProps } from "@/components/spatius-avatar/spatius-avatar-error";

export { SpatiusAvatarFrame } from "@/components/spatius-avatar/spatius-avatar-frame";
export type { SpatiusAvatarFrameProps } from "@/components/spatius-avatar/spatius-avatar-frame";

export { SpatiusAvatarLoading } from "@/components/spatius-avatar/spatius-avatar-loading";
export type { SpatiusAvatarLoadingProps } from "@/components/spatius-avatar/spatius-avatar-loading";

export { SpatiusAvatarProvider } from "@/components/spatius-avatar/spatius-avatar-provider";
export type { SpatiusAvatarProviderProps } from "@/components/spatius-avatar/spatius-avatar-provider";

export { SpatiusPrimarySessionRoot } from "@/components/spatius-avatar/spatius-primary-session-root";

export { SpatiusAvatarStatus } from "@/components/spatius-avatar/spatius-avatar-status";
export type { SpatiusAvatarStatusProps } from "@/components/spatius-avatar/spatius-avatar-status";

export {
  useOptionalSpatiusAvatarContext,
  useSpatiusAvatarContext,
} from "@/components/spatius-avatar/spatius-avatar-context";

export { useSpatiusAvatar } from "@/hooks/useSpatiusAvatar";

export type {
  SpatiusAvatarConnection,
  SpatiusAvatarConnectionStatus,
  UseSpatiusAvatarOptions,
  UseSpatiusAvatarResult,
} from "@/types/spatius-avatar";
